import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {TableDefinitionEntityModel} from "../table-definition-entity-model.service";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-table-definition-edit-page",
    templateUrl: "./table-definition-edit-page.component.html",
    providers: [(provideEntityModel(TableDefinitionEntityModel))]
})

export class TableDefinitionEditPageComponent extends AbstractEditPage {
    constructor(public model: TableDefinitionEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
